import React from 'react'
import {
  Archive14,
  Archive3,
  Archive30,
  Archive5,
  Archive7,
  FaceRec,
  Bitrate1024,
  Archive0,
} from 'sputnik-icons'

import i18next from 'i18next'

export function DeviceServiceIcons({ color, style }) {
  const serviceIcons = {
    archive_0: <Archive0 style={style} />,
    archive_3: <Archive3 color={color} style={style} />,
    archive_5: <Archive5 color={color} style={style} />,
    archive_7: <Archive7 color={color} style={style} />,
    archive_14: <Archive14 color={color} style={style} />,
    archive_30: <Archive30 color={color} style={style} />,
    bitrate_1024: <Bitrate1024 style={style} />,
    face_rec: <FaceRec style={style} />,
  }
  return serviceIcons
}

export function DeviceServiceFormattedText() {
  const serviceText = {
    archive_0: i18next.t('devices:helper_text.archive_day', { days: 0 }),
    archive_3: i18next.t('devices:helper_text.archive_day', { days: 3 }),
    archive_5: i18next.t('devices:helper_text.archive_day', { days: 5 }),
    archive_7: i18next.t('devices:helper_text.archive_day', { days: 7 }),
    archive_14: i18next.t('devices:helper_text.archive_day', { days: 14 }),
    archive_30: i18next.t('devices:helper_text.archive_day', { days: 30 }),
    face_rec: i18next.t('devices:helper_text.face_rec'),
    bitrate_1024: i18next.t('devices:helper_text.bitrate_1024'),
  }
  return serviceText
}
